import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import { BootstrapVue, IconsPlugin, EmbedPlugin } from 'bootstrap-vue';


import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import VueMask from 'v-mask';
Vue.use(VueMask);

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(EmbedPlugin);

Vue.config.productionTip = false;
store.dispatch('initAuth').then(() =>
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount('#app')
);
